import { TCreateConverter, TFetchConverter } from '../types/converter.types';
import {
  TConfigurePartnerApiPropertyDB,
  TConfigurePartnerApiPropertyUI,
  TCreatePartnerApiIntegrationDB,
  TCreatePartnerApiIntegrationUI,
  TCreatePartnerApiWebhookSubscriptionDB,
  TCreatePartnerApiWebhookSubscriptionUI,
  TPartnerApiConfiguredPropertyDB,
  TPartnerApiConfiguredPropertyUI,
  TPartnerApiIntegrationAppDB,
  TPartnerApiIntegrationAppUI,
  TPartnerApiIntegrationDB,
  TPartnerApiIntegrationDetailsDB,
  TPartnerApiIntegrationDetailsUI,
  TPartnerApiIntegrationUI,
  TPartnerApiWebhookSubscriptionDB,
  TPartnerApiWebhookSubscriptionUI,
} from '../types/partnerApiIntegration.types';

export const partnerApiIntegrationAppConverter: TFetchConverter<
  TPartnerApiIntegrationAppUI,
  TPartnerApiIntegrationAppDB
> = {
  fromDb: (data) => ({
    appId: data.appId,
    name: data.name,
    logoUrl: data.logoUrl,
    description: data.description,
  }),
};

export const partnerApiIntegrationConverter: TFetchConverter<TPartnerApiIntegrationUI, TPartnerApiIntegrationDB> = {
  fromDb: (data) => ({
    settingsId: data.id,
    name: data.name,
    appId: data.appId,
    logoUrl: data.logoUrl,
    apiKey: data.apiKey ?? null,
  }),
};

export const partnerApiConfiguredPropertyConverter: TFetchConverter<
  TPartnerApiConfiguredPropertyUI,
  TPartnerApiConfiguredPropertyDB
> = {
  fromDb: (data) => ({
    id: data.id,
    linkedPropertyId: data.linkedPropertyId,
  }),
};

export const configurePartnerApiPropertyConverter: TCreateConverter<
  TConfigurePartnerApiPropertyUI,
  TConfigurePartnerApiPropertyDB
> = {
  toDb: (data) => ({
    propertyId: data.propertyId,
  }),
};

export const partnerApiWebhookSubscriptionConverter: TFetchConverter<
  TPartnerApiWebhookSubscriptionUI,
  TPartnerApiWebhookSubscriptionDB
> = {
  fromDb: (data) => ({
    id: data.id,
    eventType: data.eventType,
    url: data.url,
  }),
};

export const createPartnerApiWebhookSubscriptionConverter: TCreateConverter<
  TCreatePartnerApiWebhookSubscriptionUI,
  TCreatePartnerApiWebhookSubscriptionDB
> = {
  toDb: (data) => ({
    eventType: data.eventType,
    url: data.url,
  }),
};

export const createPartnerApiIntegrationConverter: TCreateConverter<
  TCreatePartnerApiIntegrationUI,
  TCreatePartnerApiIntegrationDB
> = {
  toDb: (data) => ({
    appId: data.appId,
    name: data.name,
  }),
};

export const partnerApiIntegrationDetailsConverter: TFetchConverter<
  TPartnerApiIntegrationDetailsUI,
  TPartnerApiIntegrationDetailsDB
> = {
  fromDb: (data) => ({
    settingsId: data.id,
    name: data.name,
    apiKey: data.apiKey,
  }),
};